import {Component, Input} from '@angular/core';
import {Dealer} from '@ox/typings';

@Component({
  selector: 'webu-compact-dealer-info',
  templateUrl: './compact-dealer-info.component.html'
})
export class CompactDealerInfoWComponent {
  @Input() userAddress: string;
  @Input() dealer: Dealer;

  public language = window.gm.bml?.lang;
  public url = 'https://www.google.com/maps/';

  openGoogleMaps() {
    if (this.userAddress === null || this.userAddress === undefined || this.userAddress === '') {
      // sets url to display a map with only dealer address (this is used in the case the user doesn't input
      // anything into the input field for a starting address)
      // EXAMPLE URL: https://www.google.com/maps/search/?api=1&query=Google+Pyrmont+NSW
      this.url += 'search/?api=1&query=' + encodeURIComponent(this.dealer.address);
    } else {
      // sets url to display a map with directions to the dealer address
      // this will only execute if the user presses 'Get Directions' after inputting a starting address
      // EXAMPLE URL: https://www.google.com/maps/dir/?api=1&origin=Google+Pyrmont+NSW&destination=QVB
      this.url += 'dir/?api=1&origin=' + encodeURIComponent(this.userAddress) +
        '&destination=' + encodeURIComponent(this.dealer.address);
    }
    window.open(this.url);
  }

}
